import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function ZealyQuestTriggerFullDetails({ trigger }: Props) {
  const questId = useMemo(() => trigger.context?.quest_id, [trigger]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow
        label="Executed with"
        value={
          <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
            <Text as="span" variant="body-sm" color="muted">
              Participants that completed quest
            </Text>
            {questId && (
              <Badge variant="outline" size="sm">
                {questId}
              </Badge>
            )}
          </div>
        }
      />
    </KeyValueTable>
  );
}
